import React from 'react'
import { PATHS } from '@/consts/paths'

import BulletinsPage from '@/pages/Users/Bulletins'
import QueriesPage from '@/pages/Users/Queries'
import Route from './Route'

export function CommonRoutes() {
  return (
    <>
      <Route
        path={PATHS.common.bulletins}
        component={BulletinsPage}
        isPrivate
        exact
      />

      <Route
        path={PATHS.user.queries.root}
        component={QueriesPage}
        isPrivate
        exact
      />
    </>
  )
}

export default CommonRoutes
